(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["component-accordion"] && !Shopify.designMode) return;
  try {
    class ComponentAccordion extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        this.trigger = this.querySelector("[component-accordion-trigger]");
        this.target = this.querySelector("[component-accordion-target]");
        this.initClickEvents();
    }

    open() {
        this.target.classList.add("component-accordion__content-container--active");
        this.classList.add("component-accordion--active");

    }
    close() {
        this.target.classList.remove("component-accordion__content-container--active");
        this.classList.remove("component-accordion--active");
    }
    toggle() {

        this.target.classList.toggle("component-accordion__content-container--active");
        this.classList.toggle("component-accordion--active");
    }
    initClickEvents() {
        this.trigger.addEventListener("click", (e) => {
            this.toggle();
            console.log(this.target)
        });
    }
    }

    customElements.define("component-accordion", ComponentAccordion);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["component-popup"] && !Shopify.designMode) return;
  try {
    class ComponentPopup extends HTMLElement {
        constructor() {
        super();
        this._popup = null;
        this.attachShadow({ mode: 'open' });
        }

        connectedCallback() {
            if (!this.shadowRoot.hasChildNodes()) {
                const fragment = document.createDocumentFragment();

                while (this.firstChild) 
                    fragment.appendChild(this.firstChild);
                
                this.shadowRoot.append(fragment);
            }
            this.style.display = 'none';
        }

        disconnectedCallback() {
            this.close(); // clean up modal if element removed
        }

        disableScroll(status){
            if(status)
                document.body.style.overflow = "hidden";
            else 
                document.body.style.overflow = "auto";
        }
        cloneShadowContent() {
            return Array.from(this.shadowRoot.childNodes)
            .map(node => node.cloneNode(true));
        }
         
        open() {
            if (this._popup) return; 
            this.disableScroll(true);
            this._popup = document.createElement('div');
            this._popup.setAttribute("data-trigger","close-popup")
            this._popup.classList.add('component-popup-modal');
            document.body.appendChild(this._popup);
            void this._popup.offsetWidth;

            this._popup.classList.add('component-popup-modal--active');
            this._popup.append(...this.cloneShadowContent());



            this._popup.addEventListener('mousedown', (e) => {
                const target = e.target
            
                if(!target.dataset.trigger) return;

                const trigger = target.dataset.trigger;
                this.dispatchEvent(new CustomEvent(`popup-click`, {
                    bubbles: true,
                    composed: true,
                    detail: {
                    trigger,
                    target,
                    popup: this
                    }
                }));

                if (target.dataset.trigger === 'close-popup') {
                    this.close();
                }

            });

            this.setAttribute('open', '');
        }

        // The live cloned container, or null while closed. Consumers must scope their
        // queries to this — the nodes inside the element itself are the shadow originals.
        get modal() {
            return this._popup;
        }

        close() {
            if (!this._popup) return;
            this._popup.classList.remove('component-popup-modal--active');
            this.removeAttribute('open');
            this._popup.addEventListener('transitionend', () => {
                if (this._popup) {
                this._popup.remove();
                this._popup = null;
                this.disableScroll(false);
                }
            });
        }
    }
    customElements.define('component-popup', ComponentPopup);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["component-sidebar"] && !Shopify.designMode) return;
  try {
    class ComponentSideBar extends HTMLElement {
  constructor() {
    super();
    this.active = false;
  }
  connectedCallback() {
    this.closeButton();
    this.initClickEvents();
  }
  initClickEvents() {
    this.addEventListener("mousedown", (e) => {
      if (e.target === this) this.close();
    });
  }

  open() {
    this.active = true;
    this.classList.add("sidebar--active");
    document.body.style.overflow = "hidden";
  }
  close() {
    this.active = false;
    this.classList.remove("sidebar--active");
    document.body.style.overflow = "auto";
  }

  closeButton() {
    const closeButtons = this.querySelectorAll("[data-side-bar-close]");

    closeButtons.forEach((button) => {
      button.addEventListener("click", (e) => {
        this.close();
      });
    });
  }
}
customElements.define("component-side-bar", ComponentSideBar);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["customer-email-change"] && !Shopify.designMode) return;
  try {
    if (!customElements.get("customer-email-change")) {
    // This bundle is not Liquid-rendered, so every string comes from the snippet's inline
    // <script>. Read lazily — that <script> and this bundle have no guaranteed order.
    // Missing key -> undefined, and messageFor() falls back to `bad`.
    const cecMessage = (code) => window.cecMessages && window.cecMessages[code];
    // Popup header title per step, keyed `title_<step>` — including `title_email`, which
    // repeats the Liquid `popup_title` for the reset() path back to step 1.
    const cecTitle = (step) => cecMessage("title_" + step);
    // Codes that mean the server-side flow is gone — drop back to step 1.
    const CEC_FATAL = [
      "email_change_expired",
      "email_change_mismatch",
      "invalid_email_change_step",
    ];

    class CustomerEmailChange extends HTMLElement {
      constructor() {
        super();
        this.popup = null;
        this.step = "email";
        this.newEmail = "";
        this.targetEmail = "";
        this.expiresAt = 0;
        this.resendAt = 0;
        this.errorMessage = "";
        this.noticeMessage = "";
        this.flowVersion = 0;
        this.pendingRequest = null;
        this.expiryTimer = null;
      }

      connectedCallback() {
        this.popup = this.querySelector("component-popup");

        // Only the trigger button lives in this element; everything else is in the clone.
        this.addEventListener("click", (event) => {
          if (event.target.dataset.trigger === "open") this.open();
        });

        // The backdrop, header close button, and Done button are closed by component-popup.
        // Stop DOM updates while closed, but retain the flow so reopening can resume it.
        this.addEventListener("popup-click", (event) => {
          if (event.detail.trigger === "close-popup") this.clearTimers();
        });
      }

      disconnectedCallback() {
        this.clearTimers();
      }

      // The live cloned popup content, or null while closed.
      get modal() {
        return this.popup && this.popup.modal;
      }

      open() {
        this.clearTimers();
        this.popup.open();

        // New container each open, so nothing to unbind and no duplicate listeners.
        const modal = this.modal;
        modal.addEventListener("click", (event) => this.handleClick(event));
        modal.addEventListener("input", (event) => this.handleInput(event));
        modal.addEventListener("keydown", (event) => this.handleKeydown(event));
        this.renderState();
      }

      handleClick(event) {
        switch (event.target.dataset.trigger) {
          case "submit-email":
            this.startChange(event.target);
            break;
          case "submit-code":
            this.verifyCode(event.target);
            break;
          case "resend":
            this.resend(event.target);
            break;
          case "restart":
            this.reset("");
            break;
        }
      }

      // Enter in a field submits the current step. The popup content is cloned into
      // document.body, outside any host <form>, so this is convenience only.
      handleKeydown(event) {
        if (event.key !== "Enter" || !event.target.matches(".cec__input")) return;

        event.preventDefault();
        const submit = this.pane(this.step).querySelector(
          '[data-trigger="submit-email"], [data-trigger="submit-code"]',
        );
        if (submit) submit.click();
      }

      handleInput(event) {
        const field = event.target.closest("[data-cec-field]");
        if (!field) return;

        if (event.target.name === "code")
          event.target.value = event.target.value.replace(/\D/g, "");

        this.setFieldError(field, "");
      }

      // ---- steps ----------------------------------------------------------

      pane(step) {
        return this.modal.querySelector('[data-step="' + step + '"]');
      }

      showStep(step) {
        this.step = step;
        if (!this.modal) return;

        this.modal.querySelectorAll("[data-step]").forEach((pane) => {
          pane.hidden = pane.dataset.step !== step;
        });

        // The step heading IS the popup header — component-popup renders it as the only
        // <p> in .component-popup__header, inside the clone this.modal points at.
        const title = this.modal.querySelector(".component-popup__header p");
        if (title && cecTitle(step)) title.textContent = cecTitle(step);
      }

      renderState() {
        if (!this.modal) return;

        this.showStep(this.step);
        this.setError(this.errorMessage);
        this.setNotice(this.noticeMessage);

        if (this.step === "verify-current" || this.step === "verify-new") {
          this.pane(this.step).querySelector("[data-target-email]").textContent =
            this.targetEmail;
          this.startTimers();
        }

        this.renderPending();
      }

      renderPending() {
        if (!this.modal) return;

        this.modal
          .querySelectorAll(
            '[data-trigger="submit-email"], [data-trigger="submit-code"], [data-trigger="resend"], [data-trigger="restart"]',
          )
          .forEach((button) => {
            const coolingDown =
              button.dataset.trigger === "resend" && Date.now() < this.resendAt;
            button.disabled = Boolean(this.pendingRequest) || coolingDown;
            if (button.classList.contains("button-primary"))
              button.classList.remove("button-primary--loading");
          });

        if (!this.pendingRequest) return;
        const button = this.pane(this.step).querySelector(".button-primary");
        if (button) button.classList.add("button-primary--loading");
      }

      async startChange(button) {
        if (!this.validateEmailStep()) return;

        const email = this.input("email", "new_email").value.trim().toLowerCase();
        const data = await this.post("/customer/email", { email }, button);
        if (!data) return;

        this.newEmail = email;
        this.goToCodeStep("verify-current", this.dataset.currentEmail, data);
      }

      async verifyCode(button) {
        const step = this.step;
        const input = this.input(step, "code");
        const code = input.value.trim();

        if (!/^\d{6}$/.test(code)) {
          this.setFieldError(
            input.closest("[data-cec-field]"),
            cecMessage("code_required"),
          );
          return;
        }

        const path =
          step === "verify-current"
            ? "/customer/email/verify-current"
            : "/customer/email/verify-new";
        const data = await this.post(
          path,
          { email: this.newEmail, code },
          button,
        );
        if (!data) return;

        input.value = "";

        if (step === "verify-current") {
          this.goToCodeStep("verify-new", this.newEmail, data);
          return;
        }

        this.complete(data.email || this.newEmail);
      }

      async resend(button) {
        if (!this.newEmail) return;

        const data = await this.post(
          "/customer/email",
          { email: this.newEmail },
          button,
        );
        if (!data) return;

        this.goToCodeStep("verify-current", this.dataset.currentEmail, data);
        this.setNotice(cecMessage("code_resent"));
      }

      goToCodeStep(step, targetEmail, data) {
        this.step = step;
        this.targetEmail = targetEmail;
        this.expiresAt = Date.now() + (Number(data.expiresIn) || 600) * 1000;
        this.resendAt = Date.now() + (Number(data.resendAfter) || 60) * 1000;
        this.setError("");
        this.setNotice("");
        this.renderState();
      }

      complete(email) {
        this.clearTimers();
        this.expiresAt = 0;
        this.resendAt = 0;
        this.setError("");
        this.setNotice("");
        this.showStep("done");
        this.dataset.currentEmail = email;

        // Keep the read-only row on the account profile page in sync, if present.
        const display = document.querySelector("[data-email]");
        const emailInput = document.querySelector("#Account-email[name='email']");
        if (display) display.textContent = email;
        if (emailInput) emailInput.value = email;
        const triggerButton = document.querySelector(".cec__trigger");
        triggerButton.disabled = true;

      }

      reset(message) {
        this.clearTimers();
        this.flowVersion += 1;
        this.pendingRequest = null;
        this.newEmail = "";
        this.targetEmail = "";
        this.expiresAt = 0;
        this.resendAt = 0;
        this.showStep("email");
        this.setNotice("");
        this.setError(message || "");
        this.renderPending();
      }

      // ---- timers ---------------------------------------------------------

      // Deadlines are absolute: a backgrounded tab has its intervals throttled to roughly one
      // callback a minute, so anything counting callbacks drifts behind the server by minutes —
      // and this flow sends the customer off to their mail app by design.
      startTimers() {
        this.clearTimers();

        const step = this.step;
        const modal = this.modal;
        const expiry = this.pane(step).querySelector("[data-expiry]");
        // The verify-new pane has no resend — its tertiary button restarts the flow instead.
        const resendButton = this.pane(step).querySelector(
          '[data-trigger="resend"]',
        );

        const tick = () => {
          if (this.modal !== modal || this.step !== step) {
            this.clearTimers();
            return;
          }

          const remaining = (this.expiresAt - Date.now()) / 1000;
          if (remaining <= 0) {
            this.reset(cecMessage("email_change_expired"));
            return;
          }
          expiry.textContent = this.clock(Math.ceil(remaining));

          if (!resendButton) return;
          const cooldown = Math.ceil((this.resendAt - Date.now()) / 1000);
          resendButton.disabled = Boolean(this.pendingRequest) || cooldown > 0;
          resendButton.dataset.label =
            resendButton.dataset.label || resendButton.textContent;
          resendButton.textContent =
            cooldown > 0
              ? resendButton.dataset.label + " (" + this.clock(cooldown) + ")"
              : resendButton.dataset.label;
        };

        tick();
        this.expiryTimer = setInterval(tick, 1000);
      }

      clearTimers() {
        clearInterval(this.expiryTimer);
        this.expiryTimer = null;
      }

      clock(seconds) {
        const total = Math.max(0, Math.floor(seconds));
        const minutes = Math.floor(total / 60);
        return minutes + ":" + String(total % 60).padStart(2, "0");
      }

      // Prose form of clock() — for sentences, where "0:45" reads worse than "45 sec".
      // Largest whole unit only, rounded up: 45 sec, 3 min, 2 hr. Never compound.
      // ponytail: abbreviated units so the locale strings need no plural forms.
      duration(seconds) {
        const total = Math.max(1, Math.ceil(seconds));
        const unit = (value, name) =>
          cecMessage("unit_" + name).replace("time_value", value);

        if (total < 60) return unit(total, "second");
        if (total < 3600) return unit(Math.ceil(total / 60), "minute");
        return unit(Math.ceil(total / 3600), "hour");
      }

      // ---- validation -----------------------------------------------------

      input(step, name) {
        return this.pane(step).querySelector('[name="' + name + '"]');
      }

      validateEmailStep() {
        const next = this.input("email", "new_email");
        const nextValue = next.value.trim().toLowerCase();
        const field = next.closest("[data-cec-field]");

        if (!nextValue) {
          this.setFieldError(field, cecMessage("new_email_empty"));
          return false;
        }
        if (!next.checkValidity()) {
          this.setFieldError(field, cecMessage("new_email_invalid"));
          return false;
        }
        if (nextValue === this.dataset.currentEmail) {
          this.setFieldError(field, cecMessage("email_unchanged"));
          return false;
        }

        return true;
      }

      setFieldError(field, message) {
        field.classList.toggle("cec__field--error", Boolean(message));
        field.querySelector("[data-cec-error]").textContent = message;
      }

      setError(message) {
        this.errorMessage = message || "";
        const element = this.modal && this.modal.querySelector("[data-form-error]");
        if (element) element.textContent = this.errorMessage;
      }

      setNotice(message) {
        this.noticeMessage = message || "";
        const element = this.modal && this.modal.querySelector("[data-notice]");
        if (element) element.textContent = this.noticeMessage;
      }

      // ---- transport ------------------------------------------------------

      async post(path, body, button) {
        if (this.pendingRequest) return null;

        this.setError("");
        this.setNotice("");

        const request = {};
        const flowVersion = this.flowVersion;
        this.pendingRequest = request;

        // The spinner is a .button-primary::after — pointless on the tertiary resend button.
        const spinner = button && button.classList.contains("button-primary");
        if (button) button.disabled = true;
        if (spinner) button.classList.add("button-primary--loading");
        this.renderPending();

        try {
          const response = await fetch(window.apiURL + path, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
          });
          const data = await response.json().catch(() => ({}));

          // An explicit reset starts a new flow; ignore replies belonging to the old one.
          if (this.flowVersion !== flowVersion) return null;

          // Success responses carry no statusCode — trust the HTTP status.
          if (response.ok) return data;

          const code = Array.isArray(data.message)
            ? data.message[0]
            : data.message;

          if (CEC_FATAL.includes(code)) {
            this.reset(cecMessage(code));
            return null;
          }

          this.setError(this.messageFor(response.status, code, data.retryAfter));
          return null;
        } catch (error) {
          console.error(error);
          if (this.flowVersion === flowVersion)
            this.setError(cecMessage("unavailable"));
          return null;
        } finally {
          if (this.pendingRequest === request) this.pendingRequest = null;
          if (button) button.disabled = false;
          if (spinner) button.classList.remove("button-primary--loading");
          this.renderPending();
        }
      }

      messageFor(status, code, retryAfter) {
        if (status === 429) {
          if (!retryAfter) return cecMessage("too_many_requests");
          // Past half an hour an exact wait is useless — and "in 1 hr" reads as a threat.
          if (retryAfter > 1800) return cecMessage("too_many_codes");
          const key = code === "otp_send_limit" ? "otp_send_limit" : "resend_wait";
          return cecMessage(key).replace("time_value", this.duration(retryAfter));
        }
        if (status === 401) return cecMessage("unauthorized");
        if (status === 403) return cecMessage("forbidden");

        return cecMessage(code) || cecMessage("bad");
      }
    }

    customElements.define("customer-email-change", CustomerEmailChange);
  }
  } catch(e) { console.error(e); }
})();

})();
